module.exports = __webpack_public_path__ + "img/nav-issue_center.21c12263.svg";